import axios from "axios";
import { awsUrl, aspNetUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "../server/ShowAlert";
import { setPreload } from "../server/CartsOpen";

export const customerList = () => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/lists`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        if (x.data) {
          dispatch({ type: actionType.SET_SHOP_LIST, payload: x.data });
        } else {
          showAlert({
            msgTitle: "הייתה בעיה  בשליפת הרשימה",
            msgType: "error",
          });
        }
      });
  };
};

export const customerListClear = () => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_SHOP_LIST, payload: [] });
  };
};

export const addNewList = (Name, customer_list_product) => {
  const val = {
    Name,
    customer_list_product: customer_list_product ? customer_list_product : [],
  };
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .post(`${awsUrl}/v1/lists`, val, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        if (x.data) {
          dispatch({ type: actionType.ADD_NEW_SHOP_LIST, payload: x.data });
          showAlert({ msgTitle: "הרשימה נוספה בהצלחה", msgType: "success" });
        } else {
          showAlert({ msgTitle: "הייתה בעיה בהוספת הרשימה", msgType: "error" });
        }
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const customerListId = (id) => {
  return axios.get(`${awsUrl}/v1/lists/${id}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};
export const addToCard = (id, stationId) => {
  return axios.get(
    `${aspNetUrl}CustomerList/setCollectSite?CustomerListId=${id}&stationId=${stationId}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const addProductToList = (data) => {
  return axios.post(`${awsUrl}/v1/lists/product`, data, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const deleteList = (listId) => {
  return (dispatch) => {
    axios
      .delete(`${awsUrl}/v1/lists/${listId}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch({ type: actionType.DELETE_SHOP_LIST, payload: listId });
          showAlert({ msgTitle: "הרשימה נמחקה בהצלחה", msgType: "success" });
        } else {
          showAlert({ msgTitle: "הייתה בעיה במחיקת הרשימה", msgType: "error" });
        }
      });
  };
};

export const deleteAllList = (lists) => {
  const deletePromises = lists.map((list) => {
    return axios.delete(`${awsUrl}/v1/lists/${list.Id}`, {
      headers: {
        Authorization: `bearer ${localStorage.getItem("jwtToken")}`,
      },
    });
  });
  return (dispatch) => {
    Promise.all(deletePromises)
      .then(() => {
        dispatch({ type: actionType.DELETE_ALL_SHOP_LIST });
      })
      .catch((error) => {
        console.log("שגיאה במחיקת אחת או יותר מהרשימות:", error);
      });
  };
};
